import { createContext } from 'react';

export const XYChartAnnotationsHiddenTracksContext = createContext<string[]>(
  [],
);
